import { render, staticRenderFns } from "./allCertificate.vue?vue&type=template&id=45c1965b&scoped=true&"
import script from "./allCertificate.vue?vue&type=script&lang=js&"
export * from "./allCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1965b",
  null
  
)

export default component.exports